<!-- Template Rendering -->
@if (iconTemplates[`${position}-${iconType}`]; as template) {
  <ng-container *ngTemplateOutlet="template"></ng-container>
}

<!-- Template Definitions -->
<ng-template #leftArrow>
  <svg width=" 16" height="14" viewBox="0 0 16 14" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16 6.53a.98.98 0 0 1-.98.98H3.544l4.293 3.842a.98.98 0 0 1-1.307 1.46L.326 7.26a.98.98 0 0 1 0-1.46L6.53.25a.98.98 0 0 1 1.307 1.46L3.544 5.55H15.02a.98.98 0 0 1 .98.98"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #rightArrow>
  <svg width="16" height="14" viewBox="0 0 16 14" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 6.53a.98.98 0 0 1 .98-.979h11.477L8.163 1.71A.98.98 0 1 1 9.47.25l6.204 5.55a.98.98 0 0 1 0 1.46L9.47 12.813a.98.98 0 0 1-1.307-1.46l4.294-3.842H.98A.98.98 0 0 1 0 6.53"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #downArrow>
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17 10.9437L12 15.9437L7 10.9437L7.8875 10.0562L12 14.1687L16.1125 10.0562L17 10.9437Z"
      fill="currentColor" />
  </svg>
</ng-template>

<ng-template #upArrow>
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 14L12 9L17 14L16.1125 14.8875L12 10.775L7.8875 14.8875L7 14Z" fill="currentColor" />
  </svg>
</ng-template>
